export default {
  overline: {
    id: 'shopping_assistant_fab_overline',
    defaultMessage: 'Ask us',
  },
  message: {
    id: 'shopping_assistant_fab_message',
    defaultMessage: 'Need help?',
  },
  ariaLabel: {
    id: 'shopping_assistant_fab_aria_label',
    defaultMessage: 'Open Back Market AI',
  },
} as const
